module.exports = "pegasus_template/assets/themecapture1/coming_soon/100.png";